import React from 'react';

export interface ExclamationTriangleProps {
  className?: string;
  height?: string;
  width?: string;
  viewBox?: string;
}

export default function ExclamationTriangle({ className, height = '40', width = '40', viewBox = '0 0 40 40' }: ExclamationTriangleProps) {
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path
        d="M19.8461 5.53924C19.8895 5.51512 19.9437 5.5 20.0039 5.5C20.064 5.5 20.1183 5.51512 20.1617 5.53924C20.1992 5.56007 20.2487 5.59815 20.2985 5.68281L37.4409 34.8495C37.53 35.0012 37.5282 35.16 37.4462 35.3078C37.4051 35.382 37.3536 35.4309 37.3094 35.4583C37.2726 35.4811 37.2251 35.5 37.1462 35.5H2.86148C2.78258 35.5 2.73511 35.4811 2.6983 35.4583C2.65407 35.4309 2.60264 35.382 2.56152 35.3078C2.47951 35.16 2.47771 35.0012 2.56687 34.8495L19.7093 5.68281C19.759 5.59815 19.8086 5.56007 19.8461 5.53924ZM22.4538 4.41605C21.3441 2.52798 18.6636 2.52798 17.5539 4.41605L0.411564 33.5827C-0.731017 35.5267 0.640697 38 2.86148 38H37.1462C39.367 38 40.7387 35.5267 39.5962 33.5827L22.4538 4.41605Z"
        fill="#CE5347"
      />
      <path
        d="M17.5039 30.5C17.5039 29.1193 18.6231 28 20.0039 28C21.3846 28 22.5039 29.1193 22.5039 30.5C22.5039 31.8807 21.3846 33 20.0039 33C18.6231 33 17.5039 31.8807 17.5039 30.5Z"
        fill="#CE5347"
      />
      <path
        d="M17.7488 15.4876C17.6156 14.1557 18.6615 13 20 13C21.3385 13 22.3844 14.1557 22.2512 15.4876L21.3744 24.2562C21.3038 24.9623 20.7096 25.5 20 25.5C19.2904 25.5 18.6962 24.9623 18.6256 24.2562L17.7488 15.4876Z"
        fill="#CE5347"
      />
    </svg>
  );
}
